export default {"src":"/_next/static/media/quick_statistics.0ad8f77b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};